import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import { getScope } from "lib/utils/getScopeLevel"

interface summaryNoteInitialState {
  auditLogsHeartbeatStarted: boolean
  auditLogsCompleteData: any
}

const initialState: summaryNoteInitialState = {
  auditLogsHeartbeatStarted: false,
  auditLogsCompleteData: {
    video_url: "video_na",
    widget_code: "summary_notes",
    action_performed: null,
    payload: {
      seg_id: "segment_no",
      input_params_obj: {
        scope: getScope() || "scope_na",
        scope_data: "scope_data_no",
        summary_length: "detailed",
        custom_instructions: null,
      },
      assessment_obj: {},
      blob_uri: {
        complete_blob_uri: [],
        generated_blob_uri: [],
        uploaded_blob_uri: [],
        downloaded_blob_uri: [],
      },
      compute_time: 0,
      tokens_used: 0,
      cache_hit: true,
      session_timeout: false,
      usage_time_in_sec: 0,
      watch_percentage: 0,
      video_duration: 0,
    },
  },
}

const summaryNoteSlice = createSlice({
  name: "summary-notes",
  initialState,
  reducers: {
    setAuditLogsHeartbeatStarted: (state, action: PayloadAction<boolean>) => {
      state.auditLogsHeartbeatStarted = action.payload
    },
    setAuditLogsCompleteData: (state, action: PayloadAction<any>) => {
      state.auditLogsCompleteData = action.payload
    },
    resetState: () => initialState,
  },
})

export const { resetState, setAuditLogsHeartbeatStarted, setAuditLogsCompleteData } = summaryNoteSlice.actions

export default summaryNoteSlice.reducer
